export default "__VITE_ASSET__BopXca2x__"